export enum Permissions {
  VIEW_ALL_COMPANIES = 'VIEW_ALL_COMPANIES',
  VIEW_OWN_COMPANIES = 'VIEW_OWN_COMPANIES',
  VIEW_OPTIMISATION = 'VIEW_OPTIMISATION',
  EDIT_AVAILABILITY = 'EDIT_AVAILABILITY',
}
